module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "charts"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 12
    }
  }, [_c('div', {
    staticClass: "lee-panel"
  }, [_c('div', {
    staticClass: "heading warning-text"
  }, [_vm._v("\n          Line\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ve-line', {
    attrs: {
      "data": _vm.chartData,
      "settings": _vm.lineChartSettings
    }
  })], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 12
    }
  }, [_c('div', {
    staticClass: "lee-panel"
  }, [_c('div', {
    staticClass: "heading warning-text"
  }, [_vm._v("\n          Line Area\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ve-line', {
    attrs: {
      "data": _vm.chartData,
      "settings": _vm.areaChartSettings
    }
  })], 1)])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 12
    }
  }, [_c('div', {
    staticClass: "lee-panel"
  }, [_c('div', {
    staticClass: "heading warning-text"
  }, [_vm._v("\n          Histogram\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ve-histogram', {
    attrs: {
      "data": _vm.chartData,
      "settings": _vm.areaChartSettings
    }
  })], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 12
    }
  }, [_c('div', {
    staticClass: "lee-panel"
  }, [_c('div', {
    staticClass: "heading warning-text"
  }, [_vm._v("\n          Ring\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ve-ring', {
    attrs: {
      "data": _vm.chartData,
      "settings": _vm.ringChartSettings
    }
  })], 1)])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 12
    }
  }, [_c('div', {
    staticClass: "lee-panel"
  }, [_c('div', {
    staticClass: "heading warning-text"
  }, [_vm._v("\n          Funnel\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ve-funnel', {
    attrs: {
      "data": _vm.chartData,
      "settings": _vm.funnelChartSettings
    }
  })], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 12
    }
  }, [_c('div', {
    staticClass: "lee-panel"
  }, [_c('div', {
    staticClass: "heading warning-text"
  }, [_vm._v("\n          Radar\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ve-radar', {
    attrs: {
      "data": _vm.chartData,
      "settings": _vm.radarChartSettings
    }
  })], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0206de06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Chart.vue
// module id = 593
// module chunks = 1